import ToastContainer from '../components/Toast.vue'

let toastInstance = null

export default {
  install(app) {
    app.component('toast-container', ToastContainer)

    app.mixin({
      mounted() {
        if (this.$options.name === 'ToastContainer') {
          toastInstance = this
        }
      }
    })

    app.config.globalProperties.notify = function(type, msg) {
      if (toastInstance) {
        toastInstance.add(type, msg)
      }
    }
  }
}
